import type { StatusAlvo } from '../../../api/monitoramento';

interface Props {
  status: StatusAlvo;
  className?: string;
}

const MAP: Record<StatusAlvo, { classes: string; rotulo: string }> = {
  ATIVO: {
    classes:
      'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400 border-green-200 dark:border-green-800',
    rotulo: 'Ativo',
  },
  DEGRADADO: {
    classes:
      'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400 border-amber-200 dark:border-amber-800',
    rotulo: 'Degradado',
  },
  INDISPONIVEL: {
    classes:
      'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400 border-red-200 dark:border-red-800',
    rotulo: 'Indisponível',
  },
  SEM_DADOS: {
    classes:
      'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 border-gray-200 dark:border-gray-700',
    rotulo: 'Sem dados',
  },
};

/**
 * Pill local de status para a página de monitoramento.
 *
 * Criado como componente local (não genérico) para não poluir o StatusBadge
 * global com vocabulário de domínio específico (ATIVO/DEGRADADO/INDISPONIVEL).
 */
export function MonitoramentoStatusPill({ status, className = '' }: Props) {
  const { classes, rotulo } = MAP[status];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${classes} ${className}`}
    >
      {rotulo}
    </span>
  );
}
